import { useEffect, useState } from "react";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";

interface InfoAnimalSellProps {
  task: ITaskAnimalResolver | undefined;
}


export default function InfoAnimalSell(task: InfoAnimalSellProps) {
  const [taskSell, setTaskSell] = useState<ITaskAnimalResolver>();
  useEffect(() => {
    setTaskSell(task.task)
  }, []);

  const mapText = new Map();
  mapText.set("Venda", "Vivo")
  mapText.set("Abate", "Abate")

  return (
    <>
      <div >
        <span>No retiro</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AreaIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSell?.area_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div >
        <span>No lote</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AnimalsIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSell?.batch_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`Vivo ou para abate?`} pointed />
        <ButtonPressed onlyResult optionSelected={1} value={1} text={`${mapText.get(taskSell?.task_update_type)}`} />
      </div>

      {taskSell?.details.map((detail, index) => (
        <>
          {detail.categories.map((category, index) => (
            <div key={index}>
              <div className="lot__title--category" style={{ marginTop: 0 }}>{category.category_description.name}</div>
              <div className="lot__subtitle--category">{category.category_description.age_description}</div>
              <CounterInputV2 name={`info-animal-sell-qty-${index}`} value={Number(category.quantity ?? 0)} disabled />
            </div>
          ))}
        </>
      ))}
    </>
  )
}